module.exports = __webpack_public_path__ + "img/infp.14023d26.png";